var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginSvgAcium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185,
    height: 78.093,
    viewBox: "0 0 185 78.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_508",
    "data-name": "Grupo 508",
    transform: "translate(-127.071 -559.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_507",
    "data-name": "Grupo 507",
    transform: "translate(127.071 559.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1224",
    "data-name": "Caminho 1224",
    d: "M324.5,614.05a7.522,7.522,0,0,0-7.522-7.522h-17.99l.85,3.243h17.14a4.475,4.475,0,0,1,.074,8.95c-.025,0-.049,0-.074,0H299.826v3.243h17.149a4.477,4.477,0,0,1,0,8.953v-.008H299.822l-.837,2.86h17.99a7.519,7.519,0,0,0,4.4-13.619A7.511,7.511,0,0,0,324.5,614.05Z",
    transform: "translate(-205.754 -580.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1225",
    "data-name": "Caminho 1225",
    d: "M385.057,626.617,362.6,606.081v27.481l3.1-.591V613.025l22.26,20.537V606.081l-2.955.64Z",
    transform: "translate(-234.87 -580.775)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1226",
    "data-name": "Caminho 1226",
    d: "M449.3,606.251h-4.71L429.85,619.837l.049-13.586h-3v27.3l2.955-.369V619.954l14.885,13.593H449.3l-15.089-13.593Z",
    transform: "translate(-264.297 -580.853)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1227",
    "data-name": "Caminho 1227",
    d: "M127.071,627.508l9.434-1.97,14.282-28.367,14.381,28.269,9.456,2.068-23.776-47.18Z",
    transform: "translate(-127.071 -568.988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_484",
    "data-name": "Ret\\xE2ngulo 484",
    width: 1.182,
    height: 78.093,
    transform: "translate(69.961)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "financial_services",
    "data-name": "financial services",
    transform: "translate(219.375 626.902)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "financial services")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginSvgAcium);
export default __webpack_public_path__ + "static/media/loginSvgAcium.52671b0b95678936f9a827770a9bf68f.svg";
export { ForwardRef as ReactComponent };